import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "q-gutter-y-md keysearch-form" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "key-search-rightarea" }
const _hoisted_4 = { class: "keysearch-formarea flex items-center" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "key-search-rightarea" }
const _hoisted_7 = { class: "keysearch-formarea flex" }
const _hoisted_8 = { class: "key-search-label" }
const _hoisted_9 = { class: "keysearch-textarea flex" }
const _hoisted_10 = {
  key: 0,
  class: "key-search-key-value"
}
const _hoisted_11 = { class: "key-search-key-value-note column" }
const _hoisted_12 = { class: "key-search-form-caution q-mt-sm" }

import { computed } from 'vue';

// 詳細検索キー
interface KeyPullDown {
  label: string;
  value: string;
}

interface Props {
  // フリーワード
  freeWord: string;
  // キー項目
  keyData: KeyPullDown;
  // 詳細値
  keyValue: string;
  // 完全一致
  completeMatch: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'KeySearchForm',
  props: {
    freeWord: {},
    keyData: {},
    keyValue: {},
    completeMatch: { type: Boolean }
  },
  emits: [
  'clearFreeWord',
  'clearKeySearch',
  'changeFreeWord',
  'changeKeyData',
  'changeKeyValue',
  'changeCompleteMatch',
],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

// 詳細検索キー項目
const items = [
  {
    label: 'ATTO_ID',
    value: 'ATTO_ID',
  },
  {
    label: 'MDL No.',
    value: 'MDL_No',
  },
  {
    label: 'CAS No.',
    value: 'CAS_No',
  },
  {
    label: 'サプライヤ商品コード',
    value: 'サプライヤ商品コード',
  },
  {
    label: 'Smiles',
    value: 'SMILES',
  },
  {
    label: '化学名',
    value: 'NAME',
  },
];

// 入力例
const inputExample = (label: string) => {
  switch (label) {
    case 'ATTO_ID':
      return ['AT-000000001', 'AT-000000010', 'AT-000000025'];
    case 'MDL No.':
      return ['MFCD04967111', 'MFCD13186175', 'MFCD26959757'];
    case 'CAS No.':
      return ['50-32-8', '137-64-4', '91222-55-8'];
    case 'サプライヤ商品コード':
      return ['AM-1001', '10001-001e', '6127-2000-01'];
    case 'Smiles':
      return ['O=C1CCc2ccccc2C1', 'Nc1[nH]ncc1Br', 'Cl.Cl.CN(C1CNC1)C1COC1'];
    case '化学名':
      return ['Triphenylene', '(4-Methylpyridin-3-yl)methanol', '1-(2-nitrophenoxy)acetone'];
    default:
      return '';
  }
};

// フリーワード
const freeWordComputed = computed({
  get: () => props.freeWord,
  set: (value) => {
    if (value === null) {
      emit('changeFreeWord');
    } else {
      emit('changeFreeWord', value);
    }
  },
});

// 詳細検索プルダウン
const keyDataComputed = computed({
  get: () => props.keyData.label,
  set: (value) => {
    if (value === null) {
      emit('clearKeySearch');
    } else {
      emit('changeKeyData', value);
    }
  },
});

// 詳細検索テキスト
const keyValueComputed = computed({
  get: () => props.keyValue,
  set: (value) => {
    if (value === null) {
      emit('clearKeySearch');
    } else {
      emit('changeKeyValue', value);
    }
  },
});

// 完全一致
const completeMatchComputed = computed({
  get: () => props.completeMatch,
  set: (value) => {
    if (value === null) {
      emit('clearKeySearch');
    } else {
      emit('changeCompleteMatch', value);
    }
  },
});

// クリアイベント
const clearFreeWord = () => {
  emit('clearFreeWord');
};
const clearKeySearch = () => {
  emit('clearKeySearch');
};

return (_ctx: any,_cache: any) => {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-right text-subtitle1 text-weight-bold text-primary" }, "簡易検索", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_q_input, {
            modelValue: freeWordComputed.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((freeWordComputed).value = $event)),
            clearable: "",
            placeholder: "",
            outlined: "",
            dense: "",
            class: "input-area left-input",
            onClear: clearFreeWord
          }, null, 8, ["modelValue"])
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "key-search-form-caution q-mt-sm flex" }, [
          _createElementVNode("p", { class: "q-mb-none" }, [
            _createTextVNode(" 入力された検索ワードはATTO_ID、MDL No.、CAS No.、サプライヤ商品コード、化学名と総当たりで検索するため時間がかかります。"),
            _createElementVNode("br")
          ]),
          _createElementVNode("p", {
            class: "q-mt-sm q-mb-none",
            style: {"margin-left":"1rem"}
          }, " 検索条件がわかっている場合は詳細検索をご利用ください。 ")
        ], -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "text-right text-subtitle1 text-weight-bold text-primary relative" }, "詳細検索", -1)),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_q_select, {
              modelValue: keyDataComputed.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((keyDataComputed).value = $event)),
              clearable: "",
              outlined: "",
              options: items,
              "display-value": keyDataComputed.value ? keyDataComputed.value : '選択してください',
              dense: "",
              onClear: clearKeySearch
            }, null, 8, ["modelValue", "display-value"]),
            _createVNode(_component_q_checkbox, {
              modelValue: completeMatchComputed.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((completeMatchComputed).value = $event)),
              label: "完全一致",
              color: "primary",
              disable: keyDataComputed.value !== '化学名'
            }, null, 8, ["modelValue", "disable"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_q_input, {
              modelValue: keyValueComputed.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((keyValueComputed).value = $event)),
              type: "textarea",
              class: "input-area",
              outlined: "",
              autogrow: "",
              dense: "",
              disable: keyDataComputed.value === ''
            }, null, 8, ["modelValue", "disable"]),
            (keyDataComputed.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _cache[6] || (_cache[6] = _createElementVNode("span", { style: {"margin-bottom":"5px"} }, "入力例)", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(inputExample(keyDataComputed.value), (item, index) => {
                      return (_openBlock(), _createElementBlock("span", { key: index }, _toDisplayString(item), 1))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("p", _hoisted_12, " 複数件検索する場合は、改行して入力してください。最大" + _toDisplayString(_ctx.$t('validation.search_max_count')) + "件まで入力可能です。 ", 1),
        _cache[7] || (_cache[7] = _createElementVNode("p", { class: "key-search-form-caution q-mt-sm" }, " 詳細検索項目に化学名を選択した場合のみ、完全一致と部分一致の選択が可能です。化学名以外の詳細検索項目は完全一致のみとなります。 ", -1)),
        _cache[8] || (_cache[8] = _createElementVNode("p", { class: "key-search-form-caution q-mt-sm" }, " 「試薬」と「その他のカテゴリー」は同時に検索できません。 ", -1))
      ])
    ])
  ]))
}
}

})